export enum UserRolesEnum {
  SUPER_ADMIN = 1,
  CONTENT_ADMIN = 2,
  CONTENT_TEAM = 3,
  ALERTS_TEAM = 4,
  CUSTOMER_SUPPORT = 5,
  DEFAULT = 6,
}
